// App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './LanguageContext';
import { AuthProvider } from './AuthContext';
import { ProfileProvider, useProfile } from './ProfileContext';
import ProfileView from './ProfileView';
import Header from './Header';
import Feed from './Feed';
import Settings from './Settings';
import Account from './Account';
import Login from './Login';
import ProfileSetup from './ProfileSetup';
import ComposePage from './ComposePage';
import Privacy from './Privacy';
import './App.css';

// Default relay list - can be moved to config.js in the future
const DEFAULT_RELAYS = [
  "wss://relay.nostr.band",
  "wss://nos.lol",
  "wss://relay.primal.net",
  "wss://relay.nos.social",
  "wss://sources.nostr1.com"
];

const RootProfileView = ({ relays }) => {
  const { profileView, hideProfile } = useProfile();
  if (!profileView) return null;
  return (
    <ProfileView
      userMetadata={profileView.userMetadata}
      pubkey={profileView.pubkey}
      onClose={hideProfile}
      relays={relays}
    />
  );
};

const App = () => {
  const [relays, setRelays] = useState(() => {
    // Persist relays in localStorage
    const saved = localStorage.getItem('relays');
    return saved ? JSON.parse(saved) : DEFAULT_RELAYS;
  });
  
  const addRelay = (newRelay) => {
    setRelays(prev => {
      const updated = [...prev, newRelay];
      localStorage.setItem('relays', JSON.stringify(updated));
      return updated;
    });
  };

  const removeRelay = (relayToRemove) => {
    setRelays(prev => {
      const updated = prev.filter(r => r !== relayToRemove);
      localStorage.setItem('relays', JSON.stringify(updated));
      return updated;
    });
  };
  
  return (
    <AuthProvider>
      <LanguageProvider>
        <ProfileProvider>
          <Router>
            <div className="App">
              <Header />
              <main id="main-content" className="main-content" role="main">
                <Routes>
                  <Route path="/" element={<Feed relays={relays} />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/profile-setup" element={<ProfileSetup />} />
                  <Route path="/settings" element={
                    <Settings 
                      relays={relays} 
                      addRelay={addRelay} 
                      removeRelay={removeRelay} 
                    />
                  } />
                  <Route path="/account" element={<Account relays={relays} />} />
                  <Route path="/compose" element={
                    <ComposePage relays={relays} />
                  } />
                  <Route path="/privacy" element={<Privacy />} />
                </Routes>
              </main>
              <RootProfileView relays={relays} />
            </div>
          </Router>
        </ProfileProvider>
      </LanguageProvider>
    </AuthProvider>
  );
};

export default App;